import deepMerge from "lodash/merge";
import clone from "lodash/cloneDeep";
import get from "lodash/get";
// import has from "lodash/has";

export default {
  computed: {
    optionsName() {
      return this.categoryBlockName
        ? this.categoryBlockName
        : this.$options.name;
    },
    swiperOption() {
      return deepMerge(
        this.swiperDefaultOption,
        clone(
          get(
            this.config,
            `metaData.categoryblocktype_${this.optionsName}.JSON_CONFIG`
          )
        )
      );
    },
    style() {
      let style = {};
      let backgroundColor = get(
        this.config,
        `metaData.categoryblocktype_${this.optionsName}.BACKGROUND_COLOR`
      );
      if (backgroundColor) {
        style.backgroundColor = backgroundColor;
      }
      let backgroundImage;
      if (this.$vuetify.breakpoint.xsOnly) {
        backgroundImage = get(
          this.config,
          `metaData.categoryblocktype_${this.optionsName}.BACKGROUND_IMAGE_MOBILE.location`
        );
      }
      if (!backgroundImage) {
        backgroundImage = get(
          this.config,
          `metaData.categoryblocktype_${this.optionsName}.BACKGROUND_IMAGE.location`
        );
      }
      if (backgroundImage) {
        style.backgroundImage = `url("${backgroundImage}")`;
        let backgroundPosition =
          get(
            this.config,
            `metaData.categoryblocktype_${this.optionsName}.BACKGROUND_POSITION`
          ) || "top center";
        style.backgroundPosition = backgroundPosition;
        // if (
        //   has(
        //     this.config,
        //     `metaData.categoryblocktype_${this.optionsName}.TITLE`
        //   ) ||
        //   has(
        //     this.config,
        //     `metaData.categoryblocktype_${this.optionsName}.DESCRIPTION`
        //   )
        // ) {
        //   style.paddingTop = "180px";
        // }
      }
      style.paddingTop = get(
        this.config,
        `metaData.categoryblocktype_${this.optionsName}.BACKGROUND_PADDING`
      );

      return style;
    },
    modelName() {
      return get(
        this.config,
        `metaData.categoryblocktype_${this.optionsName}.MODE`,
        "ProposalImage"
      );
    }
  },
  methods: {
    getProposalModelName(proposal) {
      return get(proposal, "categoryProposalType.name", "ProposalCard");
    }
  }
};
